// frontend/src/pages/public/DocPage.jsx
import React from "react";
import { useParams, Navigate, Link } from "react-router-dom";
import Seo from "../../marketing/Seo";
import Markdown from "../../marketing/Markdown";
import { getDoc, buildToc } from "../../marketing/docsContent";
import { cx } from "../../marketing/ui";

export default function DocPage() {
  const { slug } = useParams();
  const doc = getDoc(slug);
  if (!doc) return <Navigate to="/docs" replace />;

  const toc = buildToc(doc.body);

  return (
    <>
      <Seo title={doc.title} description={doc.description} path={`/docs/${doc.slug}`} />
      <div className="xl:grid xl:grid-cols-[minmax(0,1fr)_200px] xl:gap-10">
        <article>
          <Markdown>{doc.body}</Markdown>
          <div className="mt-12 border-t border-gray-200 pt-6">
            <Link to="/docs" className="text-sm font-medium text-brand-700 hover:text-brand-800">
              ← Back to all docs
            </Link>
          </div>
        </article>

        {/* In-page TOC */}
        {toc.length > 0 && (
          <aside className="hidden xl:block">
            <nav className="sticky top-24">
              <p className="text-xs font-semibold uppercase tracking-wide text-gray-400">
                On this page
              </p>
              <ul className="mt-3 space-y-2 border-l border-gray-200">
                {toc.map((h) => (
                  <li key={h.id}>
                    <a
                      href={`#${h.id}`}
                      className={cx(
                        "-ml-px block border-l border-transparent pl-3 text-sm text-gray-500 hover:border-brand-400 hover:text-brand-700",
                        h.depth === 3 && "pl-6 text-xs",
                      )}
                    >
                      {h.text}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </aside>
        )}
      </div>
    </>
  );
}
